export default {"src":"/_next/static/media/coco_teaching.0ed67c4f.svg","height":106,"width":153,"blurWidth":0,"blurHeight":0};